import http from "./http_common";

class LocationService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  savePatientAddress(payload) {
    return http.post(`/patientAddresses/save`, payload);
  }

  getPatientAddress(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/patientAddresses/list/filter?${queryString}`);
  }

  checkAvailability(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/clinicServicePincodes/list/filter?${queryString}`);
  }

  setDefaultAddress(payload) {
    return http.put(`/patientAddresses/update-defaultaddress`, payload);
  }
}

export default new LocationService();
